module.exports = __webpack_public_path__ + "static/media/down_caret_arrow.01e7cac7.svg";